export function durationToMillis(duration?: string | null): number | null {
  if (!duration || typeof duration !== "string") {
    return null;
  }

  let days = 0;
  let timeWithMillis = duration;

  // Check if there's a dot before the time component (indicating days)
  const dayTimeSplit = duration.split(".", 2); // Split into two parts (days and time) at most
  if (dayTimeSplit.length === 2 && /^\d+$/.test(dayTimeSplit[0])) {
    // If the first part is numeric, treat it as days
    days = parseInt(dayTimeSplit[0], 10);
    timeWithMillis = dayTimeSplit[1];
  } else {
    timeWithMillis = duration; // No days present, use the entire string as time
  }

  // Now split the time into hours, minutes, seconds, and milliseconds
  const timeSplit = timeWithMillis.split(":");
  if (timeSplit.length !== 3) {
    return null; // Invalid time format (needs to have exactly hours, minutes, and seconds)
  }

  const hours = parseInt(timeSplit[0], 10);
  const minutes = parseInt(timeSplit[1], 10);

  // Split seconds and milliseconds by the last dot
  const secondsSplit = timeSplit[2].split(".");
  const seconds = parseInt(secondsSplit[0], 10);
  let millis = 0;

  // Handle the milliseconds part, which is optional
  if (secondsSplit.length === 2) {
    millis = parseInt(secondsSplit[1].slice(0, 3), 10); // Use only the first 3 digits of milliseconds
  }

  // Ensure all parts are valid numbers
  if (isNaN(hours) || isNaN(minutes) || isNaN(seconds) || isNaN(millis)) {
    return null;
  }

  // Convert each time component to milliseconds
  const daysInMillis = days * 24 * 60 * 60 * 1000;
  const hoursInMillis = hours * 60 * 60 * 1000;
  const minutesInMillis = minutes * 60 * 1000;
  const secondsInMillis = seconds * 1000;
  const millisInMillis = millis;

  // Return the total time in milliseconds
  return daysInMillis + hoursInMillis + minutesInMillis + secondsInMillis + millisInMillis;
}
